"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactRedux = require("react-redux");

var _redux = require("redux");

var _classNames = _interopRequireDefault(require("react-utils/classNames"));

var _underscore = require("underscore");

var _eventsTrackerUtils = require("lead-flows-ui/utils/eventsTrackerUtils");

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _UISelect = _interopRequireDefault(require("UIComponents/input/UISelect"));

var _UIFormControl = _interopRequireDefault(require("UIComponents/form/UIFormControl"));

var _UICheckbox = _interopRequireDefault(require("UIComponents/input/UICheckbox"));

var _UICopyTextArea = _interopRequireDefault(require("UIComponents/input/UICopyTextArea"));

var _UIButton = _interopRequireDefault(require("UIComponents/button/UIButton"));

var _UILoadingSpinner = _interopRequireDefault(require("UIComponents/loading/UILoadingSpinner"));

var _UISection = _interopRequireDefault(require("UIComponents/section/UISection"));

var _UIRadioInput = _interopRequireDefault(require("UIComponents/input/UIRadioInput"));

var _SimpleDialog = _interopRequireDefault(require("lead-flows-ui/components/common/SimpleDialog"));

var _BrandingConfig = _interopRequireDefault(require("lead-flows-ui/components/editor/dynoOptionsPanel/BrandingConfig"));

var _SimpleWrapper = _interopRequireDefault(require("lead-flows-ui/components/common/SimpleWrapper"));

var _DynoTypes = _interopRequireDefault(require("lead-flows-ui/constants/DynoTypes"));

var _DynoLocationSelector = _interopRequireDefault(require("./DynoLocationSelector"));

var _DynoTriggers = _interopRequireDefault(require("./DynoTriggers"));

var _DynoScheduling = _interopRequireDefault(require("./DynoScheduling/DynoScheduling"));

var _EmailServiceProviderStatus = _interopRequireDefault(require("./EmailServiceProviderStatus"));

var _ValidationUtils = require("lead-flows-ui/utils/ValidationUtils");

var _EmailAddress = _interopRequireDefault(require("PatternValidationJS/patterns/EmailAddress"));

var _TargetingOptionsManager = _interopRequireDefault(require("lead-flows-ui/components/editor/TargetingOptions/TargetingOptionsManager"));

var _Users = require("lead-flows-ui/actions/Users");

var _Teams = require("lead-flows-ui/actions/Teams");

var _Users2 = require("lead-flows-ui/selectors/Users");

var _Teams2 = require("lead-flows-ui/selectors/Teams");

var _Scopes = require("lead-flows-ui/selectors/Scopes");

var _Gates = require("lead-flows-ui/selectors/Gates");

var _HubSettings = require("lead-flows-ui/selectors/HubSettings");

var _SalesForceCampaignSelect = _interopRequireDefault(require("lead-flows-ui/components/editor/dynoOptionsPanel/SalesForceCampaignSelect"));

var _GoToWebinarSelector = _interopRequireDefault(require("lead-flows-ui/components/editor/dynoOptionsPanel/GoToWebinarSelector"));

var TEAM_PREFIX = 'team:';

var DynoOptionsPanel = _react.default.createClass({
  displayName: "DynoOptionsPanel",
  propTypes: {
    addValidationError: _react.default.PropTypes.func.isRequired,
    allGates: _react.default.PropTypes.array.isRequired,
    brandingEnabled: _react.default.PropTypes.bool.isRequired,
    currentEmailSubscriptionId: _react.default.PropTypes.number,
    displayOnExitIntent: _react.default.PropTypes.bool.isRequired,
    displayOnMobile: _react.default.PropTypes.bool.isRequired,
    displayOnScroll: _react.default.PropTypes.bool.isRequired,
    displayOnTimedDelay: _react.default.PropTypes.number.isRequired,
    dynoId: _react.default.PropTypes.string.isRequired,
    emailSubscriptionIdError: _react.default.PropTypes.bool.isRequired,
    emailSubscriptions: _react.default.PropTypes.array.isRequired,
    espConnectionStatus: _react.default.PropTypes.string.isRequired,
    espSubscriptionsCount: _react.default.PropTypes.number.isRequired,
    espType: _react.default.PropTypes.string.isRequired,
    fetchEspStatus: _react.default.PropTypes.func.isRequired,
    fetchingEspStatus: _react.default.PropTypes.bool.isRequired,
    fetchingEspStatusHasError: _react.default.PropTypes.bool.isRequired,
    fetchingEspStatusRecentError: _react.default.PropTypes.object,
    fetchTeams: _react.default.PropTypes.func.isRequired,
    fetchUsers: _react.default.PropTypes.func.isRequired,
    formFields: _react.default.PropTypes.array,
    formGuid: _react.default.PropTypes.string.isRequired,
    goToWebinarWebinarKey: _react.default.PropTypes.string,
    handleCompleteModal: _react.default.PropTypes.func.isRequired,
    handleUnpublish: _react.default.PropTypes.func.isRequired,
    handleUpdateEmailSubscriptionId: _react.default.PropTypes.func.isRequired,
    hasAccessToSchedulingOptions: _react.default.PropTypes.bool.isRequired,
    hasAccessToTargetingOptions: _react.default.PropTypes.bool.isRequired,
    hasEmailWriteScope: _react.default.PropTypes.bool.isRequired,
    hasEmailSubscriptionScope: _react.default.PropTypes.bool.isRequired,
    hasGDPREnforcementEnabled: _react.default.PropTypes.bool.isRequired,
    hasKickBackEmails: _react.default.PropTypes.bool.isRequired,
    hasLandingPagesScope: _react.default.PropTypes.bool.isRequired,
    hasSchedulingScope: _react.default.PropTypes.bool.isRequired,
    ignoreDurationDays: _react.default.PropTypes.number.isRequired,
    isCrmUser: _react.default.PropTypes.bool.isRequired,
    isDynoEnabled: _react.default.PropTypes.bool.isRequired,
    isSaving: _react.default.PropTypes.bool.isRequired,
    notificationEmails: _react.default.PropTypes.arrayOf(_react.default.PropTypes.string).isRequired,
    pageTypesList: _react.default.PropTypes.array.isRequired,
    publishAt: _react.default.PropTypes.number,
    publishedAt: _react.default.PropTypes.number,
    removeValidationError: _react.default.PropTypes.func.isRequired,
    savingHasError: _react.default.PropTypes.bool.isRequired,
    savingRecentError: _react.default.PropTypes.object,
    sendNotifications: _react.default.PropTypes.bool.isRequired,
    sfdcCampaignId: _react.default.PropTypes.string,
    showKickBackEmailOptions: _react.default.PropTypes.bool.isRequired,
    hasAudienceTab: _react.default.PropTypes.bool.isRequired,
    targetingOptions: _react.default.PropTypes.object,
    teams: _react.default.PropTypes.array,
    type: _react.default.PropTypes.string.isRequired,
    unpublishAt: _react.default.PropTypes.number,
    unpublishedAt: _react.default.PropTypes.number,
    updateDyno: _react.default.PropTypes.func.isRequired,
    users: _react.default.PropTypes.array,
    usersRequestState: _react.default.PropTypes.object.isRequired,
    validation: _react.default.PropTypes.object.isRequired
  },
  getDefaultProps: function getDefaultProps() {
    return {
      validation: {}
    };
  },
  getInitialState: function getInitialState() {
    return {
      showUnpublishModal: false,
      hasSaved: false,
      emailIsInvalid: false,
      invalidEmails: [],
      notificationEmails: this.props.notificationEmails,
      selectedEmbedCode: this.props.hasLandingPagesScope ? 'hubspot' : 'non_hubspot'
    };
  },
  componentWillMount: function componentWillMount() {
    var _this$props = this.props,
        fetchEspStatus = _this$props.fetchEspStatus,
        fetchingEspStatus = _this$props.fetchingEspStatus,
        formGuid = _this$props.formGuid;

    if (!fetchingEspStatus) {
      fetchEspStatus(formGuid);
    }

    this.props.fetchUsers();
    this.props.fetchTeams();
  },
  langKey: function langKey(suffix) {
    return "leadFlowEditor.leadFlowOptionsEditor." + suffix;
  },
  handleUpdateWhitelistedUrls: function handleUpdateWhitelistedUrls(urls) {
    var _this$props2 = this.props,
        updateDyno = _this$props2.updateDyno,
        addValidationError = _this$props2.addValidationError,
        removeValidationError = _this$props2.removeValidationError,
        targetingOptions = _this$props2.targetingOptions;
    var exactMatchUrls = urls.filter(function (url) {
      return url.indexOf('*') < url.length - 1;
    });
    var startsWithUrls = urls.filter(function (url) {
      return url.indexOf('*') === url.length - 1 && url.indexOf('*') > -1;
    });
    startsWithUrls = startsWithUrls.map(function (url) {
      return url.slice(0, -1);
    });

    if (urls.length > 0) {
      var allValid = true;
      (0, _underscore.each)(urls, function (url) {
        allValid = allValid && (0, _ValidationUtils.isValidDynoUrl)(url, true);
      });

      if (!allValid) {
        addValidationError('urlWhitelist', this.langKey('error.urlsMustBeValid'));
      } else {
        removeValidationError('urlWhitelist');
      }
    }

    targetingOptions.whiteList.exactMatchValues = exactMatchUrls;
    targetingOptions.whiteList.startsWithValues = startsWithUrls;
    updateDyno({
      targetingOptions: targetingOptions,
      urlWhitelist: null
    });
  },
  handleUpdatePageTypesList: function handleUpdatePageTypesList(pageTypesList) {
    var updateDyno = this.props.updateDyno;
    updateDyno({
      pageTypesList: pageTypesList
    });
  },
  handleSalesforceCampagin: function handleSalesforceCampagin(_ref) {
    var value = _ref.target.value;
    var updateDyno = this.props.updateDyno;
    updateDyno({
      sfdcCampaignId: value
    });
  },
  handleGoToWebinar: function handleGoToWebinar(_ref2) {
    var value = _ref2.target.value;
    var updateDyno = this.props.updateDyno;
    updateDyno({
      goToWebinarWebinarKey: value
    });
  },
  handleUpdateTriggers: function handleUpdateTriggers(update) {
    var _this$props3 = this.props,
        addValidationError = _this$props3.addValidationError,
        displayOnExitIntent = _this$props3.displayOnExitIntent,
        displayOnScroll = _this$props3.displayOnScroll,
        displayOnTimedDelay = _this$props3.displayOnTimedDelay,
        removeValidationError = _this$props3.removeValidationError,
        type = _this$props3.type,
        updateDyno = _this$props3.updateDyno;

    if (type !== _DynoTypes.default.POP_OVER) {
      update.displayOnExitIntent = false; // remove exit intent trigger from non-pop-over modals
    }

    updateDyno(update); // validation

    var propTriggerValues = {
      displayOnExitIntent: displayOnExitIntent,
      displayOnTimedDelay: displayOnTimedDelay,
      displayOnScroll: displayOnScroll
    };
    var nowValues = Object.assign(propTriggerValues, update);
    var anyOn = nowValues.displayOnExitIntent || nowValues.displayOnTimedDelay || nowValues.displayOnScroll;

    if (!anyOn) {
      addValidationError('triggers', this.langKey('error.selectAtLeastOneTrigger'));
    } else {
      removeValidationError('triggers');
    }
  },
  maybeRenderLocation: function maybeRenderLocation() {
    var _this$props4 = this.props,
        targetingOptions = _this$props4.targetingOptions,
        hasAccessToTargetingOptions = _this$props4.hasAccessToTargetingOptions,
        type = _this$props4.type,
        pageTypesList = _this$props4.pageTypesList;
    var normalisedStartsWithUrls = targetingOptions.whiteList.startsWithValues.map(function (url) {
      return "" + url + (url.indexOf('*') !== url.length - 1 ? '*' : '');
    });
    var whitelistedUrls = targetingOptions.whiteList.exactMatchValues.concat(normalisedStartsWithUrls);
    if (type === _DynoTypes.default.EMBEDDED || hasAccessToTargetingOptions) return null;
    return _react.default.createElement(_UISection.default, null, _react.default.createElement(_UIFormControl.default, {
      label: _react.default.createElement(_FormattedMessage.default, {
        message: this.langKey('leadFlowLocation')
      }),
      className: "private-toggle-group",
      tooltip: _react.default.createElement(_FormattedMessage.default, {
        message: this.langKey('tooltip.locationMessage')
      })
    }, _react.default.createElement(_DynoLocationSelector.default, {
      updateWhitelistedUrls: this.handleUpdateWhitelistedUrls,
      initialWhitelistedUrls: whitelistedUrls,
      updatePageTypesList: this.handleUpdatePageTypesList,
      initialPageTypesList: pageTypesList,
      helperInfo: _react.default.createElement(_FormattedMessage.default, {
        message: this.langKey('helperInfo.whitelistedUrls')
      })
    })));
  },
  maybeRenderTriggers: function maybeRenderTriggers() {
    var _this$props5 = this.props,
        type = _this$props5.type,
        displayOnExitIntent = _this$props5.displayOnExitIntent,
        displayOnScroll = _this$props5.displayOnScroll,
        displayOnTimedDelay = _this$props5.displayOnTimedDelay,
        validation = _this$props5.validation,
        hasAudienceTab = _this$props5.hasAudienceTab;
    if (type === _DynoTypes.default.EMBEDDED) return null;
    if (hasAudienceTab) return null;
    return _react.default.createElement(_UISection.default, null, _react.default.createElement(_DynoTriggers.default, {
      error: validation.triggers,
      validationMessage: (0, _ValidationUtils.maybeShowInvalidMessage)(validation.triggers),
      handleUpdateTriggers: this.handleUpdateTriggers,
      type: type,
      displayOnScroll: displayOnScroll,
      displayOnExitIntent: displayOnExitIntent,
      displayOnTimedDelay: displayOnTimedDelay
    }));
  },
  maybeRenderScheduling: function maybeRenderScheduling() {
    var _this$props6 = this.props,
        hasSchedulingScope = _this$props6.hasSchedulingScope,
        hasAccessToSchedulingOptions = _this$props6.hasAccessToSchedulingOptions,
        publishAt = _this$props6.publishAt,
        unpublishAt = _this$props6.unpublishAt,
        publishedAt = _this$props6.publishedAt,
        unpublishedAt = _this$props6.unpublishedAt,
        isDynoEnabled = _this$props6.isDynoEnabled,
        updateDyno = _this$props6.updateDyno,
        validation = _this$props6.validation,
        addValidationError = _this$props6.addValidationError,
        removeValidationError = _this$props6.removeValidationError;
    return hasSchedulingScope && hasAccessToSchedulingOptions ? _react.default.createElement(_UISection.default, {
      className: "dyno-options-panel__scheduling-options"
    }, _react.default.createElement(_DynoScheduling.default, {
      isPublished: isDynoEnabled,
      publishAt: publishAt,
      unpublishAt: unpublishAt,
      publishedAt: publishedAt,
      unpublishedAt: unpublishedAt,
      error: validation,
      onChange: updateDyno,
      addValidationError: addValidationError,
      removeValidationError: removeValidationError
    })) : null;
  },
  maybeRenderEmbedCode: function maybeRenderEmbedCode() {
    var _this = this;

    var _this$props7 = this.props,
        type = _this$props7.type,
        dynoId = _this$props7.dynoId,
        hasLandingPagesScope = _this$props7.hasLandingPagesScope;
    var selectedEmbedCode = this.state.selectedEmbedCode;
    if (type !== _DynoTypes.default.EMBEDDED) return null;
    var helpText = selectedEmbedCode === 'non_hubspot' ? this.langKey('htmlEmbedCodeTitle') : this.langKey('hublEmbedCodeTitle');
    var titleText = hasLandingPagesScope ? this.langKey('embedCodesTitle') : this.langKey('htmlEmbedCodeTitle');
    var embedCode = selectedEmbedCode === 'non_hubspot' ? "<div data-hubspot-embedded-flow=\"" + dynoId + "\"></div>" : "{% lead_flow_embedded_callout id='" + dynoId + "' %}";
    return _react.default.createElement(_UISection.default, null, _react.default.createElement(_UIFormControl.default, {
      label: _react.default.createElement(_FormattedMessage.default, {
        message: titleText
      }),
      className: "embed-code-control"
    }, _react.default.createElement("div", null, hasLandingPagesScope ? _react.default.createElement("div", null, _react.default.createElement(_UIRadioInput.default, {
      inline: true,
      defaultChecked: selectedEmbedCode === 'hubspot',
      name: "selectedEmbedCode",
      onChange: function onChange() {
        return _this.setState({
          selectedEmbedCode: 'hubspot'
        });
      }
    }, _react.default.createElement(_FormattedMessage.default, {
      message: this.langKey('hublOption')
    })), _react.default.createElement(_UIRadioInput.default, {
      inline: true,
      defaultChecked: selectedEmbedCode === 'non_hubspot',
      name: "selectedEmbedCode",
      onChange: function onChange() {
        return _this.setState({
          selectedEmbedCode: 'non_hubspot'
        });
      }
    }, _react.default.createElement(_FormattedMessage.default, {
      message: this.langKey('htmlOption')
    }))) : null, _react.default.createElement(_UIFormControl.default, {
      help: hasLandingPagesScope ? _react.default.createElement(_FormattedMessage.default, {
        message: helpText
      }) : null
    }, _react.default.createElement(_UICopyTextArea.default, {
      use: "code",
      buttonUse: "tertiary",
      value: embedCode
    })))));
  },
  maybeRenderSmallScreens: function maybeRenderSmallScreens() {
    var _this$props8 = this.props,
        type = _this$props8.type,
        displayOnMobile = _this$props8.displayOnMobile,
        updateDyno = _this$props8.updateDyno;
    if (type === _DynoTypes.default.EMBEDDED) return null;
    return _react.default.createElement(_UISection.default, null, _react.default.createElement(_UIFormControl.default, {
      className: "private-toggle-group",
      label: _react.default.createElement(_FormattedMessage.default, {
        message: this.langKey('smallScreenSizes')
      }),
      tooltip: _react.default.createElement(_FormattedMessage.default, {
        message: this.langKey('tooltip.smallScreenSizes')
      })
    }, _react.default.createElement(_SimpleWrapper.default, null, _react.default.createElement(_UICheckbox.default, {
      defaultChecked: !displayOnMobile,
      onChange: function onChange(_ref3) {
        var checked = _ref3.target.checked;
        return updateDyno({
          displayOnMobile: !checked
        });
      }
    }, _react.default.createElement(_FormattedMessage.default, {
      message: this.langKey('smallScreenSizesMessage')
    })))));
  },
  maybeRenderIgnoreDuration: function maybeRenderIgnoreDuration() {
    var _this$props9 = this.props,
        type = _this$props9.type,
        ignoreDurationDays = _this$props9.ignoreDurationDays,
        updateDyno = _this$props9.updateDyno;
    if (type === _DynoTypes.default.EMBEDDED) return null;
    return _react.default.createElement(_UISection.default, null, _react.default.createElement(_UIFormControl.default, {
      label: _react.default.createElement(_FormattedMessage.default, {
        message: this.langKey('ignoreDurationTitle')
      })
    }, _react.default.createElement(_UISelect.default, {
      className: "ignore-duration-selector",
      onChange: function onChange(evt) {
        return updateDyno({
          ignoreDurationDays: evt.target.value
        });
      },
      options: [{
        text: _react.default.createElement(_FormattedMessage.default, {
          message: this.langKey('durations.oneDay')
        }),
        value: 1
      }, {
        text: _react.default.createElement(_FormattedMessage.default, {
          message: this.langKey('durations.threeDays')
        }),
        value: 3
      }, {
        text: _react.default.createElement(_FormattedMessage.default, {
          message: this.langKey('durations.oneWeek')
        }),
        value: 7
      }, {
        text: _react.default.createElement(_FormattedMessage.default, {
          message: this.langKey('durations.twoWeeks')
        }),
        value: 14
      }, {
        text: _react.default.createElement(_FormattedMessage.default, {
          message: this.langKey('durations.oneMonth')
        }),
        value: 28
      }],
      defaultValue: ignoreDurationDays
    })));
  },
  handleNotificationEmailsChange: function handleNotificationEmailsChange(_ref4) {
    var _this2 = this;

    var currentRecipients = _ref4.target.value;
    var _this$props10 = this.props,
        addValidationError = _this$props10.addValidationError,
        removeValidationError = _this$props10.removeValidationError,
        updateDyno = _this$props10.updateDyno,
        users = _this$props10.users;
    var recipientsAreValid = true;
    var convertedRecipients = currentRecipients.map(function (recipient) {
      if (isNaN(recipient) && recipient.indexOf(TEAM_PREFIX) === -1) {
        if (_this2.validateEmailInput(recipient)) {
          var userByEmail = users.find(function (user) {
            return user.address === recipient;
          });
          return userByEmail ? userByEmail.id : recipient;
        } else {
          // eslint-disable-line no-else-return
          addValidationError('invalidEmail', _this2.langKey('emailNotifications.emailIsInvalid'));

          _this2.setState({
            emailIsInvalid: true,
            invalidEmails: _this2.state.invalidEmails.concat(recipient)
          });

          recipientsAreValid = false;
          return recipient;
        }
      } else {
        // eslint-disable-line no-else-return
        return recipient;
      }
    });

    if (recipientsAreValid) {
      this.setState({
        emailIsInvalid: false,
        invalidEmails: []
      });
      removeValidationError('invalidEmail');
    }

    updateDyno({
      notificationEmails: convertedRecipients
    });
  },
  validateEmailInput: function validateEmailInput(email) {
    return _EmailAddress.default.test(email) || email === '';
  },
  maybeRenderTargetingOptions: function maybeRenderTargetingOptions() {
    var _this$props11 = this.props,
        addValidationError = _this$props11.addValidationError,
        hasAccessToTargetingOptions = _this$props11.hasAccessToTargetingOptions,
        removeValidationError = _this$props11.removeValidationError,
        targetingOptions = _this$props11.targetingOptions,
        type = _this$props11.type,
        updateDyno = _this$props11.updateDyno,
        hasAudienceTab = _this$props11.hasAudienceTab;
    if (type === _DynoTypes.default.EMBEDDED || !hasAccessToTargetingOptions) return null;
    if (hasAudienceTab) return null;
    return _react.default.createElement(_TargetingOptionsManager.default, {
      addValidationError: addValidationError,
      removeValidationError: removeValidationError,
      targetingOptions: targetingOptions,
      updateDyno: updateDyno
    });
  },
  maybeRenderUnpublishModal: function maybeRenderUnpublishModal(showUnpublishModal) {
    var _this3 = this;

    var _this$props12 = this.props,
        handleUnpublish = _this$props12.handleUnpublish,
        handleCompleteModal = _this$props12.handleCompleteModal,
        savingHasError = _this$props12.savingHasError,
        isSaving = _this$props12.isSaving;
    var hasSaved = this.state.hasSaved;
    var confirmDisabled;
    var content;
    var headerText;
    var primaryText;
    var secondaryText;
    var onConfirm;
    confirmDisabled = false;

    if (isSaving) {
      headerText = this.langKey('unpublishModal.disablingLeadFlow');
      content = _react.default.createElement(_UILoadingSpinner.default, {
        grow: true,
        minHeight: 50
      });
      primaryText = this.langKey('unpublishModal.disabling');
      confirmDisabled = true;
      secondaryText = undefined;
    } else if (hasSaved) {
      if (savingHasError) {
        headerText = this.langKey('unpublishModal.errorMessage');
        content = _react.default.createElement("p", null, _react.default.createElement(_FormattedMessage.default, {
          message: this.langKey('unpublishModal.leadFlowNotPublishedError')
        }));
        primaryText = this.langKey('unpublishModal.close');

        onConfirm = function onConfirm() {
          _this3.setState({
            showUnpublishModal: false,
            hasSaved: false
          });

          _this3.props.updateDyno({
            enabled: true
          }); // set back enabled since it failed

        };

        secondaryText = undefined;
      } else {
        headerText = this.langKey('unpublishModal.done');
        content = _react.default.createElement("p", null, _react.default.createElement(_FormattedMessage.default, {
          message: this.langKey('unpublishModal.flowUnpublished')
        }));
        primaryText = this.langKey('unpublishModal.goToDashboard');
        secondaryText = this.langKey('unpublishModal.stayInEditor');

        onConfirm = function onConfirm() {
          _this3.setState({
            showUnpublishModal: false
          }, function () {
            handleCompleteModal();
          });
        };
      }
    } else {
      headerText = this.langKey('unpublishModal.disableLeadFlow');
      content = _react.default.createElement("p", null, _react.default.createElement(_FormattedMessage.default, {
        message: this.langKey('unpublishModal.confirmUnpublishLeadFlow')
      }));
      primaryText = this.langKey('unpublishModal.unpublishFlow');
      secondaryText = this.langKey('unpublishModal.cancel');

      onConfirm = function onConfirm() {
        _this3.setState({
          showUnpublishModal: true,
          hasSaved: true
        });

        handleUnpublish();
      };
    }

    if (showUnpublishModal) {
      var modalClassName = (0, _classNames.default)({
        leadinModal__container: true,
        'leadinModal-icon__container': true,
        'unpublish-confirmation': hasSaved && !isSaving
      });
      return _react.default.createElement(_SimpleDialog.default, {
        className: modalClassName,
        contextual: false,
        headerText: _react.default.createElement(_FormattedMessage.default, {
          message: headerText
        }),
        confirmDisabled: confirmDisabled,
        primaryText: _react.default.createElement(_FormattedMessage.default, {
          message: primaryText
        }),
        secondaryText: secondaryText ? _react.default.createElement(_FormattedMessage.default, {
          message: secondaryText
        }) : null,
        onConfirm: onConfirm,
        onReject: this.handleRejectModal
      }, _react.default.createElement("div", {
        className: "leadinModal__body"
      }, content));
    }

    return null;
  },
  handleRejectModal: function handleRejectModal() {
    this.setState({
      showUnpublishModal: false
    });
  },
  unpublishFlow: function unpublishFlow() {
    var isDynoEnabled = this.props.isDynoEnabled;

    if (isDynoEnabled) {
      (0, _eventsTrackerUtils.trackEditorInteraction)('options-panel-unpublish');
      this.setState({
        showUnpublishModal: true
      });
    }

    return false;
  },
  getNotificationEmailsOptions: function getNotificationEmailsOptions() {
    var users = this.props.users;
    return users.map(function (user) {
      return {
        text: user.address,
        value: user.id
      };
    });
  },
  getTeamOptions: function getTeamOptions() {
    var teams = this.props.teams;
    return teams.map(function (team) {
      var teamValue = "" + TEAM_PREFIX + team.id;
      return {
        text: team.name,
        value: teamValue
      };
    });
  },
  getNotificationEmailsValues: function getNotificationEmailsValues() {
    var _this$props13 = this.props,
        notificationEmails = _this$props13.notificationEmails,
        users = _this$props13.users,
        teams = _this$props13.teams;
    var invalidEmails = this.state.invalidEmails;
    return notificationEmails.map(function (email) {
      if (isNaN(parseInt(email, 10))) {
        if (email.indexOf(TEAM_PREFIX) !== -1) {
          var teamFound = teams.find(function (team) {
            return team.id === parseInt(email.replace(TEAM_PREFIX, ''), 10);
          });
          return {
            text: teamFound ? teamFound.name : '',
            value: email,
            tagUse: !teamFound ? 'error' : null
          };
        }

        return {
          text: email,
          value: email,
          tagUse: invalidEmails.find(function (e) {
            return e === email;
          }) ? 'error' : null
        };
      }

      var userFound = users.find(function (user) {
        return user.id === parseInt(email, 10);
      });
      return userFound ? userFound.id : '';
    });
  },
  maybeRenderSalesForceIntegration: function maybeRenderSalesForceIntegration() {
    var sfdcCampaignId = this.props.sfdcCampaignId;
    return _react.default.createElement(_SalesForceCampaignSelect.default, {
      selectedCampaignId: sfdcCampaignId,
      onChange: this.handleSalesforceCampagin
    });
  },
  maybeRenderGoToWebinarIntegration: function maybeRenderGoToWebinarIntegration() {
    var _this$props14 = this.props,
        formFields = _this$props14.formFields,
        goToWebinarWebinarKey = _this$props14.goToWebinarWebinarKey;
    return _react.default.createElement(_GoToWebinarSelector.default, {
      selectedWebinarId: goToWebinarWebinarKey,
      onChange: this.handleGoToWebinar,
      formFields: formFields
    });
  },
  renderUnpublishLink: function renderUnpublishLink() {
    var isDynoEnabled = this.props.isDynoEnabled;
    return _react.default.createElement(_UISection.default, null, _react.default.createElement(_UIButton.default, {
      id: "unpublish-dyno-button",
      use: "secondary",
      size: "small",
      disabled: !isDynoEnabled,
      onClick: this.unpublishFlow
    }, _react.default.createElement(_FormattedMessage.default, {
      message: "unpublish"
    })));
  },
  renderNotificationEmailSelect: function renderNotificationEmailSelect() {
    var usersRequestState = this.props.usersRequestState;
    var emailIsInvalid = this.state.emailIsInvalid;
    var notificationsValidation = emailIsInvalid ? _react.default.createElement(_FormattedMessage.default, {
      message: this.langKey('emailNotifications.emailIsInvalid')
    }) : null;

    if (usersRequestState.shouldShowLoader()) {
      return _react.default.createElement(_UILoadingSpinner.default, {
        grow: true
      });
    }

    return _react.default.createElement(_UIFormControl.default, {
      error: emailIsInvalid,
      label: _react.default.createElement(_FormattedMessage.default, {
        message: this.langKey('emailNotifications.sendNotificationsTo')
      }),
      validationMessage: notificationsValidation
    }, _react.default.createElement("div", {
      className: "email-notifications__email-text-inputs"
    }, _react.default.createElement(_UISelect.default, {
      allowCreate: true,
      multi: true,
      onChange: this.handleNotificationEmailsChange,
      options: [{
        text: _react.default.createElement(_FormattedMessage.default, {
          message: this.langKey('emailNotifications.teamSection')
        }),
        options: this.getTeamOptions()
      }, {
        text: _react.default.createElement(_FormattedMessage.default, {
          message: this.langKey('emailNotifications.individualSection')
        }),
        options: this.getNotificationEmailsOptions()
      }],
      placeholder: _react.default.createElement(_FormattedMessage.default, {
        message: this.langKey('emailNotifications.placeholder')
      }),
      value: this.getNotificationEmailsValues()
    })));
  },
  render: function render() {
    var _this$props15 = this.props,
        brandingEnabled = _this$props15.brandingEnabled,
        espConnectionStatus = _this$props15.espConnectionStatus,
        espSubscriptionsCount = _this$props15.espSubscriptionsCount,
        espType = _this$props15.espType,
        fetchingEspStatus = _this$props15.fetchingEspStatus,
        fetchingEspStatusHasError = _this$props15.fetchingEspStatusHasError,
        fetchingEspStatusRecentError = _this$props15.fetchingEspStatusRecentError,
        formGuid = _this$props15.formGuid,
        isCrmUser = _this$props15.isCrmUser;
    var showUnpublishModal = this.state.showUnpublishModal;
    var renderUnpublishLink = this.renderUnpublishLink();
    var maybeRenderUnpublishModal = this.maybeRenderUnpublishModal(showUnpublishModal);
    return _react.default.createElement("div", {
      className: "dyno-editor-options-panel"
    }, maybeRenderUnpublishModal, renderUnpublishLink, _react.default.createElement(_BrandingConfig.default, {
      brandingEnabled: brandingEnabled
    }), this.maybeRenderLocation(), this.maybeRenderTargetingOptions(), this.maybeRenderTriggers(), this.maybeRenderScheduling(), this.maybeRenderSmallScreens(), this.maybeRenderEmbedCode(), this.maybeRenderIgnoreDuration(), this.maybeRenderSalesForceIntegration(), this.maybeRenderGoToWebinarIntegration(), _react.default.createElement(_UISection.default, null, this.renderNotificationEmailSelect()), _react.default.createElement("h2", {
      className: "p-top-10"
    }, _react.default.createElement(_FormattedMessage.default, {
      message: this.langKey('emailServiceProviderStatus.pushContacts')
    })), _react.default.createElement(_EmailServiceProviderStatus.default, {
      fetching: fetchingEspStatus,
      fetchingHasError: fetchingEspStatusHasError,
      fetchingRecentError: fetchingEspStatusRecentError,
      espType: espType,
      espConnectionStatus: espConnectionStatus,
      espSubscriptionsCount: espSubscriptionsCount,
      formGuid: formGuid,
      isCrmUser: isCrmUser
    }));
  }
});

var mapStateToProps = function mapStateToProps(state) {
  return {
    hasAccessToTargetingOptions: (0, _Gates.isUngated)(state, 'Leadin:LeadFlowTargetingOptions'),
    showKickBackEmailOptions: state.gates['Leadin:DynoEmailPanel'] || state.gates['Leadin:SequentialKickbackEmails'],
    hasAudienceTab: (0, _Gates.isUngated)(state, ['LeadFlows:AudienceTargeting']),
    users: (0, _Users2.fetchUsers)(state),
    teams: (0, _Teams2.fetchTeams)(state),
    teamsRequestState: (0, _Teams2.getTeamsRequestState)(state),
    usersRequestState: (0, _Users2.getUsersRequestState)(state),
    hasLandingPagesScope: (0, _Scopes.hasScope)(state, 'landingpages-access'),
    hasEmailSubscriptionScope: (0, _Scopes.hasScope)(state, 'email-multi-subscriptions-access'),
    hasSchedulingScope: (0, _Scopes.hasScope)(state, 'lead-flows-scheduling'),
    hasAccessToSchedulingOptions: (0, _Gates.isUngated)(state, 'LeadFlows:Scheduling'),
    hasEmailWriteScope: (0, _Scopes.hasScope)(state, 'email-publish'),
    hasGDPREnforcementEnabled: (0, _HubSettings.getGDPREnforcementState)(state)
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    fetchUsers: (0, _redux.bindActionCreators)(_Users.fetchUsersIfNeeded, dispatch),
    fetchTeams: (0, _redux.bindActionCreators)(_Teams.fetchTeamsIfNeeded, dispatch)
  };
};

var _default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(DynoOptionsPanel);

exports.default = _default;
module.exports = exports.default;